// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Modal/Modal.sass
// module id = 466
// module chunks = 0